export enum PeriodEnum {
  AFTERNOON = "AFTERNOON",
  MORNING = "MORNING"
}
